/**
 * Resolve the subject apartment (building part) from an EHR building's
 * `livingRoom` list, given the persisted `building_part_id`.
 *
 * `building_part_id` is the globally-unique **adsOid** (QuickValuation.vue sends
 * `selectedBuildingPart.adsOid || ['ehitise-osa-number']`). It therefore must be
 * matched against `part.adsOid` FIRST; the `ehitise-osa-number` branch only ever
 * matches legacy rows whose persisted id is still a bare apartment number.
 *
 * There is deliberately NO `livingRoom[0]` fallback. A building like Sõle tn 15
 * holds dozens of apartments ordered by number 1,2,3,…; falling back to the
 * first one silently valued a foreign flat (eval 6139: building_part_id
 * "ER01237671" = apartment 27 / 62.3 m², but the first list entry is apartment 1
 * / 49.5 m² — which is exactly what leaked into the downloaded report while the
 * web showed the correct apartment). A non-match returns null so callers render
 * empty rather than another apartment's data. Mirrors the matcher already used
 * by QuickValuationResult.vue's `selectedBuildingPart`.
 *
 * @param {Array<object>|unknown} livingRoom  EHR `livingRoom` parts
 * @param {string|number|null|undefined} buildingPartId  persisted adsOid (or legacy number)
 * @returns {object|null} the matching part, or null when none matches
 */
export function resolveBuildingPart(livingRoom, buildingPartId) {
  if (!Array.isArray(livingRoom) || livingRoom.length === 0 || buildingPartId == null) {
    return null
  }

  const id = String(buildingPartId)

  return (
    livingRoom.find(
      part =>
        part?.adsOid === buildingPartId ||
        String(part?.adsOid) === id ||
        String(part?.['ehitise-osa-number']) === id,
    ) ?? null
  )
}
